/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentRevisionRequest {
    getFixupPrototypeFunction() { return AgentRevisionRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentRevisionRequest>): AgentRevisionRequest {
        let obj = Object.assign(new AgentRevisionRequest(), model);
        AgentRevisionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentRevisionRequest>): AgentRevisionRequest {
        if (!model) return null;
        return AgentRevisionRequest.newInstance(<AgentRevisionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentRevisionRequest) {
        if (!obj) return;

        models.AgentRevisionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentRevisionRequest): boolean {
        Object.setPrototypeOf(obj, AgentRevisionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.revision_of) {
            models.RevisionTarget.fixupPrototype(this.revision_of);
        }
        if (this.annotations) {
            for (let val of this.annotations) {
                models.Annotation.fixupPrototype(val);
            }
        }
    }

    /**
     * Chat the revision turn is appended to
     */
    chat_id: string;

    /**
     * Agent that produced the source turn
     */
    agent_id: string;

    /**
     * Tenant of the chat
     */
    tenant_id: string;

    /**
     * Natural-language summary composed by the UI, shown in the chat bubble and used by the query guard and summarizer
     */
    query: string;

    /**
     * The prior turn block being revised
     */
    revision_of: models.RevisionTarget;

    /**
     * Anchored edit instructions
     */
    annotations: Array<models.Annotation>;

    /**
     * True when sent with Send and end; informational only
     */
    end_annotation_session: boolean;

}
